<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row align-items-center">
                <div class="col-md-3">
                    <span style="font: normal normal normal 16px/25px Poppins; color: #343434;">
                        Cek Riwayat Pengiriman
                    </span>
                </div>
                <div class="col-md-7">
                    <input
                        class="form-control"
                        type="search"
                        placeholder="Masukkan Nomor TO"
                        aria-label="Search"
                        style="font: normal normal normal 14px/21px Poppins; height: 40px;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-2 text-right">
                    <button
                        class="btn btn-block"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            font-weight: 600; 
                            font: normal normal 600 14px/21px Poppins;
                            height: 40px;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">

            <div class="mb-4 row align-items-center">
                <div class="col-md-4"></div>
                <div class="col-md-4 text-center">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins; color: #343434;">Riwayat Pengiriman</h3>
                </div>
                <div class="col-md-4">
                    <div class="d-flex justify-content-end align-items-center">
                        <span style="font: normal normal normal 12px/18px Poppins; color: #343434; margin-right: 10px;">Filter tanggal</span>
                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="selected.date"
                            style="font: normal normal normal 12px/18px Poppins; width: 200px;"
                        ></flat-pickr>
                    </div>
                </div>
            </div>

            <vue-universal-table
                api_url="/api/riwayat-pengiriman/list"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :buttons="vue_universal_table.buttons"
                :process_data="vue_universal_table.process_data"
                :infinite_scroll="true"
                :hide_action_header_icon="true"
                @onUnduhFoto="handleDownload"
                @onUnduhfoto="handleDownload"

                sort_order="DESC"
                sort_by="waktu_konfirmasi"
                style="font: normal normal normal 12px/18px Poppins;"
            ></vue-universal-table>
        </div>
        <!-- Table End -->
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    export default {
        metaInfo : {
            title : 'Riwayat Pengiriman'
        },
        data () {
            let startDate = moment().startOf('month').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input mpm--transporter--flatpickr'
                },
                selected : {
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    search : '',
                    start: startDate,
                    end: currentDate
                },
                vue_universal_table : {
                    fields : [
                        {title:"NO TO", variable:"no_referensi", disable_sort: true},
                        {title:"TANGGAL TO", variable:"tgl_sl", date_format:"DD MMM YYYY", disable_sort: true},
                        {title:"STATUS", variable:"status_text", disable_sort: true},
                        {title:"WAKTU KONFIRMASI", variable:"waktu_konfirmasi", date_format:"DD MMM YYYY HH:mm:ss"},
                        {title:"NOPOL", variable:"nopol"},
                        {title:"NAMA DRIVER", variable:"driver"},
                        {title:"EKSPEDISI", variable:"ekspedisi"}
                    ],
                    buttons: [
                        { 
                            title: 'Unduh Foto', 
                            variable: 'id', 
                            class: 'btn-outline-warning fas fa-download',
                            style: 'border: 1px solid #F36F21; color: #F36F21; padding: 5px 10px; border-radius: 4px; font-size: 11px; background: transparent;',
                            condition: 'true'
                        }
                    ],
                    update : 0,
                    process_data: `
                        for (var i in data) {
                            data[i].driver = data[i].driver ? data[i].driver.replace(/[^a-zA-Z0-9\\s]/g, " ") : '-';
                        }
                    `
                },
            }
        },
        mounted () {

        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
                
                this.updateDebounceData();
            },
        },
        methods : {
            updateDebounceData: debounce(function () {
                this.vue_universal_table.update++
            }, 1500),
            
            async handleDownload(data) {
                try {
                    // Data dari vue-universal-table sudah di-JSON.stringify di emit
                    // Jadi perlu diparse kembali
                    let id;
                    if (typeof data === 'string') {
                        try {
                            id = JSON.parse(data);
                        } catch (e) {
                            id = data;
                        }
                    } else {
                        id = data;
                    }
                    
                    if (!id) {
                        this.$swal({
                            icon: 'error',
                            title: 'Error',
                            text: 'ID tidak ditemukan'
                        });
                        return;
                    }

                    // Show loading
                    this.$swal({
                        title: 'Mengunduh...',
                        text: 'Sedang mengunduh foto, mohon tunggu',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                    // Download using $http
                    const response = await this.$http.get(`/api/riwayat-pengiriman/download-photos?id=${id}`, {
                        responseType: 'blob'
                    });

                    // Close loading
                    this.$swal.close();

                    // Create blob and download
                    const blob = new Blob([response.data], { type: 'application/zip' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    
                    // Get filename from Content-Disposition header or use default
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = 'photos.zip';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
                        if (filenameMatch) {
                            filename = filenameMatch[1];
                        }
                    }
                    
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);

                    this.$swal({
                        icon: 'success',
                        title: 'Berhasil',
                        text: 'Foto berhasil diunduh',
                        timer: 2000,
                        showConfirmButton: false
                    });

                } catch (error) {
                    console.error('Download error:', error);
                    this.$swal.close();
                    
                    let errorMessage = 'Gagal mengunduh foto';
                    if (error.response && error.response.data) {
                        // Try to parse error from blob
                        const reader = new FileReader();
                        reader.onload = () => {
                            try {
                                const errorData = JSON.parse(reader.result);
                                errorMessage = errorData.message || errorMessage;
                            } catch (e) {
                                // Not JSON, use text
                                errorMessage = reader.result || errorMessage;
                            }
                            this.$swal({
                                icon: 'error',
                                title: 'Error',
                                text: errorMessage
                            });
                        };
                        reader.readAsText(error.response.data);
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: 'Error',
                            text: errorMessage
                        });
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>
